
import { apiFunction } from "../../apiCall/function";
import {
    ADMIN_LOGIN, SEND_FORGOT_OTP, CHANGE_PASSWORD,
    RESET_PASSWORD_OTP,
    RESET_PASSWORD
} from "../../apiCall/urls/auth";

export const handleLogin = (data) => {
    return apiFunction(ADMIN_LOGIN, "post", data, null, null);
};


export const sendForgotOTP = (data) => {
    return apiFunction(SEND_FORGOT_OTP, "post", data, null, null);
};


export const changePassword = (data) => {
    return apiFunction(CHANGE_PASSWORD, "post", data, null, null);
};
export const resetAdminOtpPassword = (data) => {
    return apiFunction(RESET_PASSWORD_OTP, "post", data, true, null, "AuthAdmin");
};
export const resetAdminPassword = (data) => {
    return apiFunction(RESET_PASSWORD, "post", data, true, null, "AuthAdmin");
};

// export const getStateStudentIdV2 = (studentId) => {
//     return apiFunction(URLs.STATE_STUDENT_ID+"/"+studentId, "post", {}, true, null, "AuthAdmin");
// };


